<template>
    <div class="table-responsive">
        <form :action="this.action"
              method="post"
              @submit="checkForm">
            <input type="hidden" name="_token" :value="csrf">
            <input type="hidden" name="avis" :value="avisId">
            <input type="hidden" ref="avis-status" name="status">
            <table class="table table-responsive">
                <thead>
                <th></th>
                <th>SKU</th>
                <th>Lagerplatz</th>
                <th>Anzahl</th>
                </thead>
                <tbody id="createManualModalItems">
                <tr v-for="(item, index) in items">
                    <td>
                        <button id="createModal_item_add" class="form-control glyphicon glyphicon glyphicon-plus" type="button" v-on:click="splitItem(item)" />
                        <button id="createModal_item_delete" class="form-control glyphicon glyphicon glyphicon-minus" type="button" v-on:click="deleteItem(index)" />
                    </td>
                    <td><auto-complete-text-edit :url="urlSku"
                                                 :placeholder="placeholder"
                                                 :name="name"
                                                 v-model="item.sku"
                                                 v-on:newValue="handleNewSku"
                                                 :index="index"
                                                 :key="componentKey">
                    </auto-complete-text-edit></td>
                    <td><auto-complete-text-edit :url="urlPlaces"
                                                 :placeholder="placeholderPlaces"
                                                 name="storage_places[]"
                                                 v-model="item.place"
                                                 v-on:newValue="handleNewPlace"
                                                 :index="index"
                                                 :key="componentKey"></auto-complete-text-edit></td>
                    <td><input type="text" name="quantity[]" placeholder="createModal_quantity" class="form-control" v-model="item.quantity" /></td>
                </tr>
                </tbody>
            </table>
            <div class="col-md-offset-6 col-md-6">
                <button id="book_avis" type="submit" class="form-control">{{$t('page.management.booking.book')}}</button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "AvisBook",
        data: function() {
            return {
                items: [],
                componentKey: 0,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        props: {
            placeholder: String,
            placeholderPlaces: String,
            name: String,
            urlSku: String,
            urlPlaces: String,
            origin: Object,
            action: String,
            avisId: String,
        },
        created: function(){
            this.origin.items.forEach(function (item) {
                vue.items.push({sku: item.sku+"", place: item.place+"", quantity: item.quantity})
            });
        },
        methods: {
            splitItem: function (item) {
                this.items.push({sku: item.sku, place: item.place, quantity: 0})
            },
            deleteItem: function (index) {
                console.log(this.items[index]);
                Vue.delete(this.items, index);

                this.componentKey += 1;
            },
            handleNewSku: function (newValue, index) {
                Vue.set(this.items[index], 'sku', newValue);
            },
            handleNewPlace: function (newValue, index) {
                Vue.set(this.items[index], 'place', newValue);
            },
            checkForm: function (e) {
                let data = {};
                let lessThan = false;
                let moreThan = false;
                let submitform = true;

                this.items.forEach(function (item) {
                    if( data[item.sku] == null){
                        data[item.sku] = parseInt(item.quantity);
                    } else {
                        data[item.sku] += parseInt(item.quantity);
                    }
                });

                this.origin.items.forEach(function (item) {
                    if( data[item.sku] < item.quantity ){
                        lessThan = true;
                    } else if(data[item.sku] > item.quantity){
                        moreThan = true;
                    }
                });

                this.status = null;
                // warning if you book less than the original items
                if( lessThan ){
                    if(confirm(this.$t('page.management.book.avis.confirm_less'))){
                        this.$refs['avis-status'].value = 'less';
                    } else {
                        submitform = false;
                    }
                // warning if you book more than the original items
                } else if( moreThan ){
                    if(confirm(this.$t('page.management.book.avis.confirm_more'))){
                        this.$refs['avis-status'].value = 'more';
                    } else {
                        submitform = false;
                    }
                }

                if( !submitform ) {
                    e.preventDefault();
                }
            }
        }

    }
</script>

<style scoped>

</style>